import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

const SearchableDropdown = ({ placeholder = 'Ara...', onSelectionChange, fetchDataFunction, data }) => {
    const dispatch = useDispatch();
    const [searchTerm, setSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (searchTerm) {
            dispatch(fetchDataFunction(searchTerm));
        }
    }, [searchTerm, fetchDataFunction, dispatch]);

    const handleSelection = (item) => {
        setSearchTerm(item.v);
        setIsOpen(false);
        if (onSelectionChange) {
            onSelectionChange(item);
        }
    };

    return (
        <div className="relative">
            <input
                className="w-full py-2 px-4 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => setIsOpen(true)}
                onBlur={() => setTimeout(() => setIsOpen(false), 200)}
            />
            {isOpen && data && data.length > 0 && (
                <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 max-h-60 overflow-auto shadow-lg">
                    {data.map((item) => (
                        <li
                            key={item.k}
                            className="py-2 px-4 hover:bg-blue-100 cursor-pointer"
                            onClick={() => handleSelection(item)}
                        >
                            {item.v} {item.r ? `(${item.r.v})` : ""}
                        </li>
                    ))}

                </ul>
            )}
        </div>
    );
};

export default SearchableDropdown;
